import * as yup from "yup";
import React, {FC} from "react";
import {useHistory} from "react-router-dom";
import {Form, Formik} from "formik";
import {CircularProgress, IconButton, InputAdornment} from "@material-ui/core";
import {FormikTextField} from "../../../form/FormikTextField";
import {Check, Close} from "@material-ui/icons";
import {useService, useUpdateService} from "../redux/services.hook";

const validationSchema = yup.object({
    name: yup.string().required('required').min(2, 'to short'),
    subtitle: yup.string().notRequired().min(2, 'to short')
});

export const EditServiceForm: FC<{ id: string }> = ({id}) => {
    const history = useHistory();
    const {updateService} = useUpdateService();
    const {service} = useService(id);
    const [isLoading, setIsLoading] = React.useState(false);

    const quitForm = () => history.replace({search: undefined});

    return (
        <Formik
            initialValues={{
                name: service?.name ?? '',
                active: Boolean(service?.active),
                subtitle: service?.subtitle
            }}
            onSubmit={(dto) => {
                setIsLoading(true);
                updateService(id, dto)
                    .catch(() => {
                    })
                    .finally(() => {
                        setIsLoading(false);
                        quitForm();
                    })
            }}
            validationSchema={validationSchema}
        >
            {({submitForm}) => (
                <Form style={{paddingLeft: 8, paddingRight: 4}}>
                    {/*<Grid container spacing={0}>*/}
                    {/*    <Grid item xs={12}>*/}
                            <FormikTextField
                                required
                                fullWidth
                                name={"name"}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position={"end"}>
                                            {isLoading
                                                ? <CircularProgress size={32}/>
                                                : (
                                                    <>
                                                        <IconButton size="small" edge={"end"} onClick={quitForm}>
                                                            <Close/>
                                                        </IconButton>
                                                        <IconButton color={"secondary"} size="small" edge={"end"}
                                                                    onClick={submitForm}>
                                                            <Check/>
                                                        </IconButton>
                                                    </>
                                                )
                                            }
                                        </InputAdornment>
                                    )
                                }}
                            />
                        {/*</Grid>*/}
                        {/*<Grid item xs={12}>*/}
                            <FormikTextField
                                required
                                fullWidth
                                placeholder="Subtitel zb. Saugen, Wischen etc"
                                name={"subtitle"}
                            />
                    {/*    </Grid>*/}
                    {/*</Grid>*/}
                </Form>
            )}
        </Formik>
    )
}
